import {
  cartRoute,
  gardenContinuationPageRoute,
  gardenQuestionnaireRoute,
  pestContinuationPageRoute,
  pestInLawnQuestionnaireRoute,
} from '~/routes';
import { cookies } from '~/utils/cookie';

export function navigateToNextFunnelPage(
  isYardFunnelEnabled,
  skipContinuationPage,
  lawnUuid,
  navigate
) {
  // This timeout should ensure that the Plan Tier Selected event is sent before the
  // user is navigated to the add-ons page.
  if (isYardFunnelEnabled) {
    const yardIssuesCookie = cookies?.get('YARD_ISSUES');
    if (skipContinuationPage) {
      // If user is in YARD_CONTINUATION_TEST skip straight to next quiz after choosing a plan
      if (yardIssuesCookie?.includes('pest')) {
        return setTimeout(() => {
          navigate(pestInLawnQuestionnaireRoute(lawnUuid));
        }, 0);
      } else if (yardIssuesCookie?.includes('garden')) {
        return setTimeout(() => {
          navigate(gardenQuestionnaireRoute(lawnUuid));
        }, 0);
      }
    } else {
      if (yardIssuesCookie?.includes('pest')) {
        return setTimeout(() => {
          navigate(pestContinuationPageRoute(lawnUuid));
        }, 0);
      } else if (yardIssuesCookie?.includes('garden')) {
        return setTimeout(() => {
          navigate(gardenContinuationPageRoute(lawnUuid));
        }, 0);
      }
    }
  }
  setTimeout(() => {
    navigate(cartRoute());
  }, 0);
}
